import { CHATBOX_ADD, CHATBOX_REMOVE } from "../constants/actionTypes";

var initialState = {
    isLoading: false,
    isError: false,
    ChatBox: [],
    MaxChatBox: 3
}
const chatboxReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHATBOX_ADD:
            let find = null
            if (state.ChatBox.length < state.MaxChatBox) {
                find = state.ChatBox.find(f => f.Id === action.payload.Id)
                if (!find)
                    return {
                        ...state,
                        ChatBox: [...state.ChatBox, action.payload]
                    }
            }
            return { ...state }
        case CHATBOX_REMOVE:
            if (state.ChatBox.length > 0) {
                let ChatBox = state.ChatBox.slice()
                ChatBox = ChatBox.filter(f => f.Id !== action.payload.Id)
                return {
                    ...state,
                    ChatBox
                }
            }
            else
                return { ...state }
        default:
            return state
    }
}

export default chatboxReducer